import React, { useEffect, useState } from 'react'
import CancellationExpensesForm, {
  CaseCATreatmentDataFormType,
} from '../components/forms/CancellationExpensesForm'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import {
  CaseCARespType,
  CaseReportParamsType,
  CaseReportRespType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import { putCaseReport } from '../services/case-report/put'

export type CancellationExpensesPageProps = {
  transitions: CancellationExpensesPageTransitions
}

export type CancellationExpensesPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const CancellationExpensesPage = (props: CancellationExpensesPageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  const handleCancelTreatmentDataPageSubmitted = (
    // Dostali jsme podmnožinu dat typu CaseCADataType
    cancelTreatments: CaseCATreatmentDataFormType
  ) => {
    const {
      loadedCaseReportResp,
    }: { loadedCaseReportResp: CaseReportRespType | undefined } = state

    const caseCARefresh: CaseCARespType = {
      ...loadedCaseReportResp?.caseCA,
      ...cancelTreatments,
    }

    const newCaseReportDataResp = {
      ...loadedCaseReportResp,
      caseCA: caseCARefresh,
    } as CaseReportRespType

    // 2. Pripravena finalni data, ktera se budou odesilat
    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    // 3. aktualizujeme state -- do currentCaseReportData nastavime newCaseReportDataResp
    //    + zustavame zatim na stejne strance
    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 4 },
    })

    // 4. data posilame na server funkcí, která odesílá data na server a obsluhuje (loading+error)
    //    A) nejdrive to napiseme v teto komponente -- do funkce
    //    B) POZDEJI -- V JINEM KROKU -- pak zrefaktorujeme do jednotneho hook (jako useGetData)
    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      //history.push(pathToBankAccount)
      props.transitions.goToNextPage()
    },
  })

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [ifEqual])

  const { fetch: fetchData, pending: loading } = useGetData({})

  React.useEffect(() => {
    fetchData()
  }, [])

  const handleBackButtonPage = () => {
    // history.push(pathToCancellation)
    props.transitions.goBack()
  }

  const currentCancelTreatmentData: CaseCATreatmentDataFormType | undefined =
    // magie: z plneho typu CaseCARespType se stavaji CaseCATreatmentDataFormType,
    // pokud jsou typy kompatibilni
    state.loadedCaseReportResp?.caseCA

  return (
    <CancellationExpensesForm
      caseReportId={state.caseReportId!}
      cancelTreatmentData={currentCancelTreatmentData}
      onPageContinue={handleCancelTreatmentDataPageSubmitted}
      onPageBack={handleBackButtonPage}
      errorMessage={state.error}
      isContinueInProgress={pending}
      isDataLoading={loading}
      setIfEqual={setIfEqual}
    />
  )
}

export default CancellationExpensesPage
